import { render, staticRenderFns } from "./ProductionViewer.vue?vue&type=template&id=67636c94&scoped=true"
import script from "./ProductionViewer.vue?vue&type=script&lang=js"
export * from "./ProductionViewer.vue?vue&type=script&lang=js"
import style0 from "./ProductionViewer.vue?vue&type=style&index=0&id=67636c94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67636c94",
  null
  
)

export default component.exports